// extracted by mini-css-extract-plugin
module.exports = {"container":"FormattedLabel_container__3HdiO","additionalInfo":"FormattedLabel_additionalInfo__3y7gg"};